import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Blog.css';

interface BlogPostProps {
  title: string;
  date: string;
  summary: string;
  content?: string;
  imageUrl?: string;
  tags: string[];
  slug: string;
  active: boolean;
}

const BlogPost: React.FC<BlogPostProps> = ({ 
  title, 
  date, 
  summary, 
  imageUrl, 
  tags,
  slug,
  active
}) => {
  return (
    <div className="blog-card">
      {imageUrl && (
        <div className="blog-image">
          <img src={imageUrl} alt={title} />
        </div>
      )}
      <div className="blog-content">
        <div className="blog-date">{date}</div>
        <h3 className="blog-title">{title}</h3>
        <p className="blog-summary">{summary}</p>
        <div className="blog-tags">
          {tags.map((tag, index) => (
            <span key={index} className="blog-tag">{tag}</span>
          ))}
        </div>
        {active ? (
          <Link to={`/blog/${slug}`} className="read-more">
            Read More
          </Link>
        ) : (
          <span className="coming-soon">Coming Soon</span>
        )}
      </div>
    </div>
  );
};

/* Commented out subscription form functionality
const SubscriptionForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Basic email validation
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      // Call the serverless function
      const response = await fetch('/.netlify/functions/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      
      const data = await response.json();
      
      if (data.success) {
        setSubmitted(true);
      } else {
        setError(data.message || 'Failed to subscribe. Please try again.');
      }
    } catch (err) {
      console.error('Error submitting form:', err);
      setError('An error occurred. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="subscription-container">
      <h3 className="subscription-title">Join My Mailing List</h3>
      <p className="subscription-description">
        Subscribe to receive my latest blog posts directly in your inbox.
      </p>
      
      {submitted ? (
        <div className="subscription-success">
          <p>Thank you for subscribing! You'll receive my latest blogs via email.</p>
        </div>
      ) : (
        <form className="subscription-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="subscription-input"
              aria-label="Email address"
              disabled={loading}
            />
            <button type="submit" className="subscription-button" disabled={loading}>
              {loading ? 'Submitting...' : 'Subscribe'}
            </button>
          </div>
          {error && <p className="subscription-error">{error}</p>}
        </form>
      )}
    </div>
  );
};
*/

const Blog: React.FC = () => {
  const blogPosts: BlogPostProps[] = [
    {
      title: "The Story of Appilo: Building a Better App Manager",
      date: "May 8, 2025",
      summary: "How Appilo evolved from an ambitious all-in-one app manager to a focused analytics and management tool, and the lessons learned along the way.",
      tags: ["Development", "Appilo", "Product Story", "React", "Electron"],
      slug: "building-of-appilo",
      active: true
    },
    {
      title: "My Homelab Setup with a Working Firewall and SIEM",
      date: "May 20, 2025",
      summary: "A security student's journey into repurposing an old PC into a Proxmox server, setting up an internal pfSense firewall, and integrating Wazuh SIEM for hands-on learning.",
      tags: ["Security", "Homelab", "pfSense", "Wazuh", "SIEM", "Networking"],
      slug: "homelab-security-setup",
      active: true
    }
  ];

  return (
    <section className="blog-section" id="blog">
      <div className="blog-container">
        <h2 className="section-title">Blog</h2>
        <p className="section-description">
          Thoughts, insights, and experiences from my journey in software development and cybersecurity.
        </p>
        
        <div className="blog-grid">
          {blogPosts.map((post, index) => (
            <BlogPost key={index} {...post} />
          ))}
        </div>
        
      </div>
    </section>
  );
};

export default Blog; 